import { __assign, __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-316b072f"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = ["onClick"];
var _hoisted_3 = { style: { flex: 'auto' } };
var _hoisted_4 = { class: "product-title" };
var _hoisted_5 = { class: "describe" };
var _hoisted_6 = { class: "time" };
var _hoisted_7 = { class: "right-box" };
var _hoisted_8 = ["src"];
import { reactive, ref } from "vue";
import { Toast } from "vant";
import Artical from "@/components/artical.vue";
import { requestArticalList } from "@/api";
import { debounce } from "@/utils";
import { useRoute } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ArticalList',
    setup: function (__props) {
        var _this = this;
        var route = useRoute();
        var loading = ref(false);
        var finished = ref(false);
        var pageParams = reactive({
            pageIndex: 0,
            pageSize: 10,
        });
        var productsList = ref([]);
        var getProductsList = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, records;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        pageParams.pageIndex++;
                        return [4 /*yield*/, requestArticalList({
                                pageIndex: pageParams.pageIndex,
                                pageSize: pageParams.pageSize,
                                data: route.query.articleType
                                    ? Number(route.query.articleType)
                                    : 1,
                            }).catch(function () {
                                Toast("系统错误-02");
                                finished.value = true;
                            })];
                    case 1:
                        res = _b.sent();
                        loading.value = false;
                        if (res.code === 200) {
                            if (pageParams.pageIndex === 1) {
                                productsList.value = [];
                            }
                            records = (_a = res.data.records) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                                var _a;
                                return __assign(__assign({}, item), { skuPrice: (_a = item.skuPrice) === null || _a === void 0 ? void 0 : _a.toFixed(2) });
                            });
                            productsList.value = productsList.value.concat(records);
                            finished.value = res.data.pages <= pageParams.pageIndex;
                        }
                        else {
                            finished.value = true;
                            Toast(res.message);
                            productsList.value = [];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var debounceGetProductsList = debounce(getProductsList, 300);
        var onLoad = function () {
            loading.value = true;
            debounceGetProductsList();
        };
        var articalVisible = ref(false);
        var articalId = ref(0);
        var viewDetails = function (id, releaseChannel, url) {
            if (releaseChannel === void 0) { releaseChannel = 1; }
            if (url === void 0) { url = ""; }
            if (releaseChannel === 1) {
                // 后台发布
                articalVisible.value = true;
                articalId.value = id;
            }
            else {
                // 2-公众号发布
                location.href = url;
            }
        };
        return function (_ctx, _cache) {
            var _a;
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_list = _resolveComponent("van-list");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: ((_a = _unref(route).query) === null || _a === void 0 ? void 0 : _a.articleType) == '2' ? '感染领域' : '肿瘤领域'
                }, null, 8, ["title"]),
                _createVNode(_component_van_list, {
                    style: _normalizeStyle({ marginTop: '0.16rem' }),
                    loading: loading.value,
                    "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) { return ((loading).value = $event); }),
                    finished: finished.value,
                    "finished-text": "没有更多了",
                    onLoad: onLoad
                }, {
                    default: _withCtx(function () { return [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, function (item) {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "product-item",
                                key: item.skuId,
                                onClick: function ($event) { return (viewDetails(item.articleId, item.releaseChannel, item.url)); }
                            }, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("p", _hoisted_4, _toDisplayString(item.articleTitle), 1),
                                    _createElementVNode("p", _hoisted_5, _toDisplayString(item.articleSubtitle), 1),
                                    _createElementVNode("p", _hoisted_6, _toDisplayString(item.releaseTime), 1)
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("img", {
                                        src: item.coverPictureUrl
                                            ? item.coverPictureUrl
                                            : require('@/assets/default.png'),
                                        alt: ""
                                    }, null, 8, _hoisted_8)
                                ])
                            ], 8, _hoisted_2));
                        }), 128))
                    ]; }),
                    _: 1
                }, 8, ["style", "loading", "finished"]),
                (articalVisible.value)
                    ? (_openBlock(), _createBlock(Artical, {
                        key: 0,
                        articalId: articalId.value,
                        onCancel: _cache[1] || (_cache[1] = function ($event) { return (articalVisible.value = false); })
                    }, null, 8, ["articalId"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
